module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SuperHeavyItalic.8737c5a.woff2";